/* eslint camelcase: 0 */
import { MonitaroGatewayBase } from './base'
import { toOrderProps, toUpdateOrderRequest } from './translator/order'
import { toQuery, toQueryProps } from './translator/query'
import { EmptyResponsePropsFactory } from '@/entities/Response'
import { IQueryProps } from '@/entities/Query'
import { FetchOrder, PostOrder, PutOrder, GetOrder, PostOrderExec } from '@/infrastructure/network/Monitaro/requests/order'
import { IOrderProps } from '@/entities/Order'

export default class Order extends MonitaroGatewayBase {
  async FetchOrder(query?: IQueryProps) {
    const response = await this.apiClient.request(new FetchOrder(toQuery(query)))
    return EmptyResponsePropsFactory({
      items: response.orders.map((prop) => toOrderProps(prop)),
      query: toQueryProps(response.query)
    })
  }

  async PostOrder(params: IOrderProps) {
    const { order } = await this.apiClient.request(new PostOrder(toUpdateOrderRequest(params)))
    return toOrderProps(order)
  }

  async PutOrder() {
    const { order } = await this.apiClient.request(new PutOrder())
    return toOrderProps(order)
  }

  async GetOrder(id: string) {
    const { order } = await this.apiClient.request(new GetOrder(id))
    return toOrderProps(order)
  }

  async PostOrderExec(id: string) {
    const { order } = await this.apiClient.request(new PostOrderExec(id))
    return toOrderProps(order)
  }
}
